import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-select-con-foto',
  templateUrl: './select-con-foto.component.html',
  styleUrls: ['./select-con-foto.component.scss'],
})
export class SelectConFotoComponent implements OnInit {
  @Input() Datos: Array<{Nombre:"", Foto:"", Value:""}>=[] 
  @Input() disabled:boolean = false;
  @Input() Titulo = "";
  valueO = []
  cant = 0
  
  @Input() set value(val){
    let t = ""
    t = JSON.stringify(val)
    this.valueO=JSON.parse(t)
    this.cant = this.valueO.length
  }
  public open=false
  @Output() Valor = new EventEmitter();

  constructor() { }

  ngOnInit() {}

  Cambio(valor){
    let ban = false;
    for(let i in this.valueO){
      if(this.valueO[i]==valor){
        this.valueO.splice(Number(i),1)
        ban = true
      }
    }
    if(!ban){
      this.valueO.push(valor)
    }

  }

  Activo(value): boolean{
    for(let i of this.valueO){
        if(value == i){
          return true;
        }
      }
      return false;
  }

  Seleccionar(){
    let value = []
    for(let i of this.Datos){
      if(this.Activo(i.Value)){
        value.push(i.Value)
      }
    }
    
    this.Valor.emit(value)
    this.cant = value.length
  }

}
